<template>
    <van-popup v-model="show" position="bottom">
        <van-datetime-picker v-model="currentDate" :type="type" :title="title" :min-date="minDate" :max-date="maxDate"
            :formatter="formatter" @cancel="onCancel" @confirm="onConfirm" />
    </van-popup>
</template>
<script>
import { timeFormat } from "@/utils/baseFormat";
export default {
    name: 'selectDatePopup',
    props: {
        showSelectDatePopup: {
            type: Boolean,
            default: false
        },
        select: {
            type: String,
            default: ''
        },
        minDate: {
            type: Date,
            default: () => new Date(1910, 0, 1)
        },
        maxDate: {
            type: Date,
            default: () => new Date(2050, 0, 1)
        },
        title: {
            type: String,
            default: '选择日期'
        },
        type: {
            type: String,
            default: 'date'
        }
    },
    data() {
        return {
            currentDate: '',
        }
    },
    computed: {
        show: {
            get() {
                return this.showSelectDatePopup
            },
            set(value) {
                this.$emit("update:showSelectDatePopup", value);
            }
        },
        selectValue: {
            get() {
                return this.select
            },
            set(value) {
                this.$emit("update:select", value);
            }
        }
    },
    methods: {
        onConfirm(e) {
            this.selectValue = timeFormat(e, "yyyy-mm-dd")
            this.show = false
        },
        onCancel() {
            this.show = false
        },
        formatter(type, val) {
            if (type === 'year') {
                return val + '年';
            }
            if (type === 'month') {
                return val + '月';
            }
            if (type === 'day') {
                return val + '日';
            }
            return val;
        },
    },
    watch: {
        show: {
            handler(value) {
                if (value && this.select) {
                    this.currentDate = new Date(this.select)
                }
            },
            immediate: true,
        },
    }
}
</script>
<style lang="scss" scoped></style>